import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

/**
 * A page somebody is not allowed to be on.
 *
 * Shown **instead of** the screen, not alongside it. The page used to render
 * in full — header, "Add employee", "Import from a spreadsheet" — with the
 * refusal sitting in the middle where the table would be. Every one of those
 * buttons opened its form, and every form failed on submit, because the
 * server refuses what the menu had already decided not to offer.
 *
 * The shell stays around it on purpose: somewhere to go next beats a dead end,
 * which is the same reason the route error boundary sits inside the shell.
 */
export function NoAccessPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="You do not have access to this"
      subTitle="If you think you should, ask HR — access follows your role."
      extra={
        <Button type="primary" onClick={() => void navigate('/')}>
          Back to home
        </Button>
      }
    />
  );
}
